import React, { useEffect, useState } from 'react';
import {
  Button,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  FormLabel,
  Tooltip,
} from '@material-ui/core';
import { Formik } from 'formik';
import { css } from '@emotion/core';
import { Observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { toJS } from 'mobx';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { safeFalsy } from '../util/UtilFunctions';
import { ContactSchema } from '../../validation';
import { StyledForm, ButtonFlex, ErrorText } from '../styles/styles';
import { useRootStore } from '../../stores/BridgeProvider';

const ContactForm = ({
  contact = {},
  buttons,
  contactAddresses,
  fetchContact,
  deepLink,
  contactAgent,
}) => (
  <Observer
    render={() => {
      const { orgStore, authStore, dataStore } = useRootStore();
      const history = useHistory();
      const addressObj = {
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        Country: '',
        IsPrimary: '0',
        AddressTypeId: '1',
      };
      const [addressList, setAddressList] = useState(contactAddresses || []);
      const [caChange, setCaChange] = useState(false);

      useEffect(() => {
        if (addressList.length > 0) {
          const val = [...addressList];
          val[0].IsPrimary = 1;
          setAddressList(val);
        }
      }, [addressList.length]);

      useEffect(() => {
        if (contact.ContactId) {
          const initialAddresses = JSON.stringify(
            JSON.parse(contact.Addresses),
          );
          const adListString = JSON.stringify(addressList);
          initialAddresses !== adListString
            ? setCaChange(true)
            : setCaChange(false);
        }
      });

      const addAddress = () => {
        setAddressList([...addressList, addressObj]);
      };

      const handleAddressChange = (index, event) => {
        const values = [...addressList];
        values[index][event.target.name] = event.target.value;
        setAddressList(values);
      };

      const submitContact = async (values, actions) => {
        const Addresses = JSON.stringify([...addressList]);
        if (!contact.ContactId) {
          const {
            FirstName,
            LastName,
            Name,
            Email,
            Phone,
            ContactTypeId,
            IsAgent,
          } = values;
          try {
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/contact`,
              {
                FirstName,
                LastName,
                Name,
                Email,
                Phone,
                ContactTypeId,
                Addresses,
                IsAgent,
              },
            );
            await dataStore.retrieveContacts();
            history.push(
              contactAgent ? '/organization/agent-contacts' : '/contacts',
            );
          } catch (e) {
            console.error(e);
            actions.setSubmitting(false);
          }
        } else {
          const {
            ContactId,
            FirstName,
            LastName,
            Name,
            Email,
            Phone,
            ContactTypeId,
            IsAgent,
          } = values;
          try {
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/contact`,
              {
                ContactId,
                FirstName,
                LastName,
                Name,
                Email,
                Phone,
                ContactTypeId,
                Addresses,
                IsAgent,
              },
            );
            fetchContact();
            await dataStore.retrieveContacts();
            history.push('/contacts');
          } catch (e) {
            console.error(e);
          }
        }
      };

      return (
        <Formik
          validationSchema={ContactSchema}
          initialValues={{
            ContactId: safeFalsy(contact.ContactId),
            FirstName: safeFalsy(contact.FirstName),
            LastName: safeFalsy(contact.LastName),
            Name: safeFalsy(contact.Name),
            Email: safeFalsy(contact.Email),
            Phone: safeFalsy(contact.Phone),
            ContactTypeId: safeFalsy(contact.ContactTypeId, null),
            IsAgent: safeFalsy(contact.IsAgent, contactAgent ? 1 : 0),
          }}
          onSubmit={async (values, actions) => submitContact(values, actions)}
          render={({
            handleBlur,
            handleChange,
            errors,
            handleSubmit,
            values,
            isSubmitting,
            dirty,
            touched,
            setFieldValue,
          }) => {
            const showError = val => errors[val] && touched[val];
            const changeArray = [dirty, caChange];
            const changes = changeArray.every(x => x === false);

            return (
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <div style={{ margin: '0 auto' }}>
                    <Typography variant="h2">
                      {contact.ContactId ? 'Edit Contact' : 'New Contact'}
                    </Typography>
                  </div>
                  {contact.ContactId && deepLink !== '#' && (
                    <Tooltip
                      title="View Contact In Xero"
                      placement="left"
                      arrow
                    >
                      <a
                        style={{ color: '#263238', textDecoration: 'none' }}
                        href={deepLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <ExitToAppIcon />
                      </a>
                    </Tooltip>
                  )}
                </div>
                <StyledForm onSubmit={handleSubmit}>
                  <TextField
                    name="Name"
                    label={
                      <div>
                        Contact Name <span style={{ color: 'red' }}>*</span>
                      </div>
                    }
                    value={values.Name}
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                    // error={showError('Name')}
                  />
                  {showError('Name') && <ErrorText>{errors.Name}</ErrorText>}
                  <div
                    css={css`
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      width: 100%;
                    `}
                  >
                    <TextField
                      name="FirstName"
                      label="First Name"
                      value={values.FirstName}
                      margin="normal"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="outlined"
                      fullWidth
                      error={showError('FirstName')}
                    />
                    <TextField
                      name="LastName"
                      label="Last Name"
                      value={values.LastName}
                      margin="normal"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="outlined"
                      fullWidth
                      error={showError('LastName')}
                    />
                  </div>
                  <TextField
                    name="Email"
                    label="Email"
                    value={values.Email}
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                    error={showError('Email')}
                  />
                  <TextField
                    name="Phone"
                    label="Phone"
                    value={values.Phone}
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="tel"
                    variant="outlined"
                    fullWidth
                    error={showError('Phone')}
                  />
                  {/* Address section Start */}
                  {addressList.map((a, index) => {
                    return (
                      <div style={{ width: '100%' }} key={index}>
                        <h4 style={{ textAlign: 'left' }}>
                          {index === 0
                            ? 'Primary Address'
                            : 'Secondary Address'}
                        </h4>
                        <TextField
                          name="Address1"
                          label="Address 1"
                          onChange={event => handleAddressChange(index, event)}
                          onBlur={handleBlur}
                          value={a.Address1 || ''}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />

                        <TextField
                          name="Address2"
                          label="Address 2"
                          onChange={event => handleAddressChange(index, event)}
                          onBlur={handleBlur}
                          value={a.Address2}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                        <div
                          css={css`
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            width: 100%;
                          `}
                        >
                          <TextField
                            name="City"
                            label="City"
                            onChange={event =>
                              handleAddressChange(index, event)
                            }
                            onBlur={handleBlur}
                            value={a.City || ''}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                          />

                          <TextField
                            name="State"
                            label="State"
                            onChange={event =>
                              handleAddressChange(index, event)
                            }
                            onBlur={handleBlur}
                            value={a.State || ''}
                            margin="normal"
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <TextField
                          name="Zip"
                          label="Zip code"
                          onChange={event => handleAddressChange(index, event)}
                          onBlur={handleBlur}
                          value={a.Zip || ''}
                          margin="normal"
                          type="tel"
                          variant="outlined"
                          fullWidth
                        />
                        <TextField
                          name="Country"
                          label="Country"
                          onChange={event => handleAddressChange(index, event)}
                          onBlur={handleBlur}
                          value={a.Country || ''}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                        />
                        <FormControl fullWidth style={{ marginTop: '16px' }}>
                          <FormLabel
                            style={{
                              textAlign: 'left',
                              marginBottom: '14px',
                              fontWeight: '500',
                            }}
                          >
                            Address Type
                          </FormLabel>
                          <RadioGroup
                            row
                            name="AddressTypeId"
                            value={a.AddressTypeId.toString()}
                            onChange={event =>
                              handleAddressChange(index, event)
                            }
                          >
                            <FormControlLabel
                              value="1"
                              control={<Radio />}
                              label="Postal Address"
                            />
                            <FormControlLabel
                              value="2"
                              control={<Radio />}
                              label="Street Address"
                            />
                            <FormControlLabel
                              value="3"
                              control={<Radio />}
                              label="Legal Address"
                            />
                            <FormControlLabel
                              value="4"
                              control={<Radio />}
                              label="Other"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    );
                  })}
                  {/* Address section End */}
                  <div
                    style={
                      addressList.length >= 2
                        ? { display: 'none' }
                        : { width: '100%', display: 'flex', margin: '14px 0' }
                    }
                  >
                    <Button
                      size="small"
                      disableRipple
                      onClick={() => addAddress()}
                    >
                      <CirclePlusIcon
                        style={{ marginRight: '4px', marginLeft: '-3px' }}
                      />{' '}
                      Address
                    </Button>
                  </div>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={contactAgent}
                          checked={!!values.IsAgent}
                          onChange={(x, bool) =>
                            setFieldValue('IsAgent', bool ? 1 : 0)
                          }
                          value={values.IsAgent}
                          error={showError('IsAgent') && values.IsAgent}
                        />
                      }
                      label="Contact is Agent"
                    />
                  </div>

                  <ButtonFlex>
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      size="large"
                      disabled={changes || isSubmitting}
                      style={{
                        margin: '5px',
                      }}
                    >
                      Submit
                    </Button>
                    <Button
                      color="secondary"
                      variant="outlined"
                      size="large"
                      onClick={() => history.goBack()}
                      style={{
                        margin: '5px',
                      }}
                    >
                      Cancel
                    </Button>
                    {buttons &&
                      buttons.map(button => <div key={button}>{button}</div>)}
                  </ButtonFlex>
                </StyledForm>
              </div>
            );
          }}
        />
      );
    }}
  />
);

export default ContactForm;
